import React, { useState } from "react";
import { connect } from "react-redux";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import TittleLine from "../../../../components/Common/TittleLine";
import CheckRender from "../../../../components/Common/CheckRender";
import ModalLoader from "../../../../components/Common/ModalLoader";
import CustomAlert from "../../../../components/Common/CustomAlert";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import ProcedimientosStandVirtualBusquedaForm from "../components/ProcedimientosStandVirtualBusquedaForm";
import ProcedimientosStandVirtualBusquedaDetalle from "../components/ProcedimientosStandVirtualBusquedaDetalle";
import ProcedimientosStandVirtualSeleccionarDocumentos from "../components/ProcedimientosStandVirtualSeleccionarDocumentos";
import ConfiguracionStandVirtualActions from "../../../../stores/cobertura/Actions";
import { useUpdateEffect, useMountEffect } from "../../../../hooks/LifeCycle";
import useEmpresa from "../../../../hooks/useEmpresa";
import { isObjectEmpty } from "../../../../utils/ObjectUtil";
import { mostrarErrorGenerico } from "../../../../utils/AlertUtils";
import { isNumber } from "../../../../utils/NumberUtil";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import Tooltip from "../../../../components/Common/Tooltip";
import { Form, FormGroup } from "../../../../components/CustomForm/FormStyles";
import CustomIcon from "../../../../components/Common/CustomIcon";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomIconInput from "../../../../components/CustomForm/CustomIconInput";

const ProcedimientosStandVirtualScreen = (props) => {
  const empresa = useEmpresa();

  useState(false);
  const [mostrarDocumentos, setMostrarDocumentos] = useState(false);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const [guardandoDocumentos, setGuardandoDocumentos] = useState(false);
  const [tiposProcedimiento, setTiposProcedimiento] = useState([]);
  const [tiposProcedmientoSeleccionado, setTiposProcedmientoSeleccionado] =
    useState(null);
  const [coberturas, setCoberturas] = useState([]);
  const [coberturaSeleccionada, setCoberturaSeleccionada] = useState(null);
  const [coberturaDocumentos, setCoberturaDocumentos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [filtroCobertura, setFiltroCobertura] = useState("");

  const showModalLoader = () => {
    const {
      datosTiposCoberturaLoading,
      datosCoberturaLoading,
      guardarCoberturaDocumentosLoading
    } = props;
    return (
      datosTiposCoberturaLoading ||
      datosCoberturaLoading ||
      guardarCoberturaDocumentosLoading
    );
  };

  useMountEffect(() => {
    const { numeroSesionReutilizable } = props?.authUserData;
    props.obtenerDatosTipoCoberutas({
      numeroSesion: numeroSesionReutilizable,
      compania: empresa?.CODIGO
    });
  });

  /*
   * obtenerDatosTipoCoberturas Success.
   */
  useUpdateEffect(() => {
    if (
      !props.datosTiposCoberturaData ||
      props.datosTiposCoberturaData.length === 0
    ) {
      setMostrarDetalle(false);
      setShowAlert(false);
      setTiposProcedimiento([]);
      setShowAlert(true);
      return;
    }

    setShowAlert(false);
    setMostrarDetalle(false);
    setTiposProcedimiento(props.datosTiposCoberturaData);
  }, [props.datosTiposCoberturaData]);

  /*
   * obtenerDatosTipoCoberutas Error.
   */
  useUpdateEffect(() => {
    if (isObjectEmpty(props.datosTiposCoberturaError)) return;

    setMostrarDetalle(false);
    setShowAlert(false);
    setTiposProcedimiento([]);
    mostrarErrorGenerico(
      props.datosTiposCoberturaError,
      () => {},
      setAlertConfig,
      setShowAlert
    );
  }, [props.datosTiposCoberturaError]);

  const handleOnSearch = (value) => {
    if (!isNumber(value) || value === 0) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: "Favor seleccione un tipo de procedimiento.",
        onConfirm: () => {
          setShowAlert(false);
        }
      });

      setShowAlert(true);
      return;
    }

    const { numeroSesionReutilizable } = props?.authUserData;

    setFiltroCobertura("");
    setMostrarDetalle(false);
    setCoberturaSeleccionada(null);
    setCoberturas([]);
    setCurrentPage(1);
    setTiposProcedmientoSeleccionado(Number(value));
    props.obtenerDatosCoberutas({
      numeroSesion: numeroSesionReutilizable,
      compania: empresa?.CODIGO,
      tipoCobertura: value
    });
  };

  /*
   * datosCoberturaData Success.
   */
  useUpdateEffect(() => {
    setShowAlert(false);
    setMostrarDetalle(false);

    if (!props.datosCoberturaData) return;

    if (
      !props.datosCoberturaLoading &&
      props.datosCoberturaData?.length === 0
    ) {
      setMostrarDetalle(false);
      setShowAlert(false);
      setCoberturas([]);
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message:
          "No se encontraron coberturas disponibles para este tipo de procedimiento.",
        onConfirm: () => {
          setShowAlert(false);
        }
      });

      setShowAlert(true);
      return;
    }

    // Agregar tipoProcedimiento a cada cobertura
    const coberturasConTipo = props?.datosCoberturaData?.map((item) => ({
      ...item,
      tipoProcedimiento: tiposProcedmientoSeleccionado
    }));

    setCoberturas(coberturasConTipo);
    setMostrarDetalle(props?.datosCoberturaData?.length > 0);
  }, [props.datosCoberturaData, tiposProcedmientoSeleccionado]);

  /*
   * datosCoberturasError Error.
   */
  useUpdateEffect(() => {
    if (isObjectEmpty(props.datosCoberturasError)) return;
    setMostrarDetalle(false);
    setShowAlert(false);
    setCoberturas([]);
    mostrarErrorGenerico(
      props.datosCoberturaError,
      () => {},
      setAlertConfig,
      setShowAlert
    );
  }, [props.datosCoberturaError]);

  /*
   * datosCoberturaDocumentoData Success.
   */
  useUpdateEffect(() => {
    setShowAlert(false);

    if (
      !props.datosCoberturaDocumentoData ||
      props.datosCoberturaDocumentoData.length === 0
    )
      return;
    setCoberturaDocumentos(props.datosCoberturaDocumentoData);
    setMostrarDocumentos(true);
  }, [props.datosCoberturaDocumentoData]);

  /*
   * datosCoberturaDocumentoError Error.
   */
  useUpdateEffect(() => {
    if (isObjectEmpty(props.datosCoberturaDocumentoError)) return;
    mostrarErrorGenerico(
      props.datosCoberturaDocumentoError,
      () => {},
      setAlertConfig,
      setShowAlert
    );
  }, [props.datosCoberturaDocumentoError]);

  const handleOnViewDocuments = (item) => {
    if (!item.cobertura) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message:
          "Por favor, primero realice una búsqueda de tipo de procedimiento.",
        onConfirm: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
      return;
    }

    setCoberturaDocumentos([]);
    setMostrarDocumentos(false);
    setCoberturaSeleccionada(item);

    props.obtenerCoberturaDocumentos({
      numeroSesion: props?.authUserData.numeroSesionReutilizable,
      compania: empresa?.CODIGO,
      tipoProcedimiento: item.tipoProcedimiento,
      cobertura: item.cobertura
    });
  };

  const handleOpenAsignarDocumentos = (item) => {
    setCoberturaDocumentos([]);
    setMostrarDocumentos(false);
    setCoberturaSeleccionada(item);

    props.obtenerCoberturaDocumentos({
      numeroSesion: props?.authUserData.numeroSesionReutilizable,
      compania: empresa?.CODIGO,
      tipoProcedimiento: item.tipoProcedimiento,
      cobertura: item.cobertura
    });
  };

  const handleOnCloseModal = () => {
    setCoberturaDocumentos([]);
    setMostrarDocumentos(false);
    setCoberturaSeleccionada(null);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleOnSaveSelectedDocuments = (items) => {
    setGuardandoDocumentos(true);
    props.guardarCoberturaDocumentos({
      tipoProcedimiento: tiposProcedmientoSeleccionado,
      cobertura: coberturaSeleccionada.cobertura,
      documentos: items,
      numeroSesion: props?.authUserData.numeroSesionReutilizable,
      compania: empresa?.CODIGO
    });
  };

  /*
   * guardarCoberturaDocumentosData Success.
   */
  useUpdateEffect(() => {
    if (!guardandoDocumentos) return;
    setAlertConfig({
      type: "info",
      title: "Configuración Guardadas Correctamente",
      message: props.guardarCoberturaDocumentosData.mensaje,

      onConfirm: () => {
        setShowAlert(false);
        handleOnCloseModal();
      }
    });

    setGuardandoDocumentos(false);
    setShowAlert(true);
  }, [props.guardarCoberturaDocumentosData]);

  /*
   * guardarCoberturaDocumentosError Error.
   */
  useUpdateEffect(() => {
    if (isObjectEmpty(props.guardarCoberturaDocumentosError)) return;
    setGuardandoDocumentos(false);
    mostrarErrorGenerico(
      props.guardarCoberturaDocumentosError,
      () => {},
      setAlertConfig,
      setShowAlert
    );
  }, [props.guardarCoberturaDocumentosError]);

  const onFiltrarPorCobertura = (clean = false) => {
    const { numeroSesionReutilizable } = props?.authUserData;

    setMostrarDetalle(false);
    setCoberturaSeleccionada(null);
    setCoberturas([]);
    setCurrentPage(1);
    props.obtenerDatosCoberutas({
      numeroSesion: numeroSesionReutilizable,
      compania: empresa?.CODIGO,
      tipoCobertura: tiposProcedmientoSeleccionado,
      cobertura: clean ? "" : filtroCobertura
    });
  };

  const handleBuscarCoberturas = (e = null) => {
    e?.preventDefault();
    onFiltrarPorCobertura();
  };

  const onClean = () => {
    if (filtroCobertura === "") return;
    setFiltroCobertura("");
    onFiltrarPorCobertura(true);
  };

  useUpdateEffect(() => {
    setShowAlert(false);
    setAlertConfig({});
  }, []);

  return (
    <>
      <Section>
        <TittleLine title={"Configuración de Documentos"} weight={"bold"} />
      </Section>

      <ProcedimientosStandVirtualBusquedaForm
        tiposCobertura={tiposProcedimiento}
        onSearch={handleOnSearch}
      />
      <CheckRender allowed={tiposProcedmientoSeleccionado}>
        <Section justify={"space-between"} padding={"10px 0px"}>
          <Tooltip
            text="Asisgnar Documentos a todas las coberturas de asociadas al tipo de procedimiento"
            position="top"
          >
            <CustomButton
              label={"Asignar Documentos "}
              width={"250px"}
              bgColor={empresa.COLOR_SECUNDARIO}
              hoverColor={empresa.COLOR_PRINCIPAL}
              onClick={handleOpenAsignarDocumentos}
            />
          </Tooltip>

          <Form onSubmit={handleBuscarCoberturas}>
            <FormGroup width={"100%"}>
              <CustomIconInput
                type={"text"}
                placeholder={
                  "Buscar por código o descripción del procedimiento"
                }
                width={"360px"}
                value={filtroCobertura}
                onChange={(e) => setFiltroCobertura(e)}
                icons={
                  <>
                    <Tooltip text="Buscar">
                      <CustomIcon
                        icon={SearchOutlined}
                        style={{
                          color: empresa?.COLOR_PRINCIPAL,
                          fontSize: 30
                        }}
                        hoverColor={empresa?.COLOR_SECUNDARIO}
                        onClick={() => onFiltrarPorCobertura()}
                      />
                    </Tooltip>
                    <Tooltip text="Limpiar">
                      <CustomIcon
                        icon={DeleteOutlined}
                        style={{
                          color: empresa?.COLOR_PRINCIPAL,
                          fontSize: 30
                        }}
                        hoverColor={empresa?.COLOR_SECUNDARIO}
                        onClick={onClean}
                      />
                    </Tooltip>
                  </>
                }
              />
            </FormGroup>
          </Form>
        </Section>
      </CheckRender>

      <CheckRender allowed={mostrarDetalle}>
        <ProcedimientosStandVirtualBusquedaDetalle
          coberturas={coberturas}
          onSelectedDocument={handleOnViewDocuments}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          totalItems={coberturas.length}
          onPageChange={handlePageChange}
        />
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>

      <CustomModal isOpen={mostrarDocumentos} onClose={handleOnCloseModal}>
        <ProcedimientosStandVirtualSeleccionarDocumentos
          documentos={coberturaDocumentos}
          tipoProcedimiento={coberturaSeleccionada}
          onGuardarSeleccionados={handleOnSaveSelectedDocuments}
          tipoProcedimientoNombre={tiposProcedmientoSeleccionado}
        />
      </CustomModal>
    </>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  datosTiposCoberturaData: state.cobertura.obtenerTipoCoberturasData,
  datosTiposCoberturaLoading: state.cobertura.obtenerTipoCoberturasLoading,
  datosTiposCoberturaError: state.cobertura.obtenerTipoCoberturasError,

  datosCoberturaData: state.cobertura.obtenerCoberturasData,
  datosCoberturaLoading: state.cobertura.obtenerCoberturasLoading,
  datosCoberturaError: state.cobertura.obtenerCoberturasError,

  datosCoberturaDocumentoData: state.cobertura.obtenerCoberturaDocumentosData,
  datosCoberturaDocumentoLoading:
    state.cobertura.obtenerCoberturaDocumentosLoading,
  datosCoberturaDocumentoError: state.cobertura.obtenerCoberturaDocumentosError,

  guardarCoberturaDocumentosData:
    state.cobertura.guardarCoberturaDocumentosData,
  guardarCoberturaDocumentosLoading:
    state.cobertura.guardarCoberturaDocumentosLoading,
  guardarCoberturaDocumentosError:
    state.cobertura.guardarCoberturaDocumentosError
});

const mapDispatchToProps = {
  obtenerDatosTipoCoberutas:
    ConfiguracionStandVirtualActions.obtenerTipoCoberturas,
  obtenerDatosCoberutas: ConfiguracionStandVirtualActions.obtenerCoberturas,
  obtenerCoberturaDocumentos:
    ConfiguracionStandVirtualActions.obtenerCoberturaDocumentos,
  guardarCoberturaDocumentos:
    ConfiguracionStandVirtualActions.guardarCoberturaDocumentos
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ProcedimientosStandVirtualScreen);
